<script setup lang="ts">
import { ElSwitch } from 'element-plus'
import { useSlots } from 'vue'

import BoxComponent from './BoxComponent.vue'
import FlexComponent from './FlexComponent.vue'
import TitleComponent from './TitleComponent.vue'

defineProps<{
  title?: string
  name?: string
}>()
defineSlots<{ tooltip?(): void }>()
const slots = useSlots()

const value = defineModel<boolean>('modelValue')
</script>
<template>
  <BoxComponent>
    <FlexComponent justify="space-between" :gap="8">
      <TitleComponent v-if="title" :title="title">
        <template v-if="slots.tooltip" #tooltip>
          <slot name="tooltip" />
        </template>
      </TitleComponent>
      <ElSwitch v-model="value" size="large" :name="name" />
    </FlexComponent>
  </BoxComponent>
</template>
<style lang="scss" scoped>
:deep(.el-switch) {
  --el-switch-on-color: var(--primary);
  --el-switch-off-color: var(--surface);
  --el-switch-border-color: var(--primary);
  .el-switch__action {
    background: var(--primary);
  }
  &.is-checked {
    .el-switch__action {
      background: var(--inverted);
    }
  }

  &.el-switch--large {
    .el-switch__core {
      border: 2px solid var(--primary);
      min-width: 52px;
      height: 32px;
      border-radius: 100px;

      .el-switch__action {
        width: 16px;
        height: 16px;
        left: 4px;
      }
    }

    &.is-checked {
      .el-switch__core {
        .el-switch__action {
          left: calc(100% - 26px);
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
</style>
